(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
    if (!customElements.get('product-recommendations')) {
      customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
        constructor() {
          super();

          const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            fetch(this.dataset.url)
              .then((response) => response.text())
              .then((text) => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('product-recommendations');

                if (recommendations?.innerHTML.trim()) {
                  this.innerHTML = recommendations.innerHTML;
                }

                if (html.querySelector('.grid__item')) {
                  this.classList.add('product-recommendations--loaded');
                }
              })
              .catch((error) => console.error(error));
          };

          new IntersectionObserver(
            handleIntersection.bind(this),
            { rootMargin: '0px 0px 200px 0px' }
          ).observe(this);
        }
      });
    }
  
  } catch(e) { console.error(e); }
})();
})();
